import {Base64} from 'js-base64';
import Pako from 'pako';

/**
 * Run gzip compression on a string and return the result as a URL-safe base64 string.
 */
export function compressToURLSafeBase64(value: string): string {
  const zippedBytes = Uint8Array.from(Pako.gzip(value));
  return Base64.fromUint8Array(zippedBytes, true);
}

/**
 * Take a URL-safe base64 gzipped string and decompress it into its source value.
 */
export function decompressFromURLSafeBase64(value: string): string {
  const zippedBytes = Base64.toUint8Array(value);
  return Pako.ungzip(zippedBytes, {to: 'string'});
}
